module.exports = __webpack_public_path__ + "img/privacy_policy_border.97d23bcf.svg";